import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles(() => ({
  wrapper: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  popinContainer: {
    display: "flex",
    flex: 1,
  },
  inputContainer: {
    width: "50%",
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 32,
  },
}));
